module.exports = __webpack_public_path__ + "img/boolfix.527efd5b.png";